import * as React from 'react';

import { useUserContext } from '@/contexts/user';
import { EntryRacer, EntryRacerNote } from '@/lib/apollo/types/gen/graphql';

import { MemoOff, MemoOn } from './style';

interface RacerNoteProps {
  entryRacer: EntryRacer;
  entryRacerNoteList?: EntryRacerNote[];
  showEntryRacerNoteModal?: (entryRacer: EntryRacer) => void;
}

const RacerNote: React.FC<RacerNoteProps> = ({
  entryRacer,
  entryRacerNoteList,
  showEntryRacerNoteModal,
}) => {
  const { isMember } = useUserContext();

  if (!(isMember && entryRacerNoteList && showEntryRacerNoteModal)) {
    return <></>;
  }

  const entyryRacerNoteCount = entryRacerNoteList
    ? entryRacerNoteList.filter(
        ern => ern.registrationNum === entryRacer.registrationNum,
      ).length
    : 0;

  return (
    <>
      {entyryRacerNoteCount > 0 ? (
        <MemoOn onClick={() => showEntryRacerNoteModal(entryRacer)} />
      ) : (
        <MemoOff onClick={() => showEntryRacerNoteModal(entryRacer)} />
      )}
    </>
  );
};

export default RacerNote;
